import * as Article from "./Article";
import * as Brand from "./Brand";
import * as Category from "./Category";
import * as Checkout from "./Checkout";
import * as MyAccount from "./MyAccount";
import * as Page from "./Page";

import ViewsLoading from "./ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

export default {
    page: Page,
    my_account: MyAccount,
    product: loadable(() => import("./Product"), options),
    customer_service: loadable(() => import("./CustomerService"), options),
    storm_category: Category,
    article: Article,
    storm_checkout: Checkout,
    storm_brand: Brand,
};
